import React, { createContext, useContext, useMemo } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { TariffKindInternal } from '../../../../../data-access/gql-types/graphql';
import { ChildrenProps } from '../../../../../types/common';
import { TariffConfigurationBody } from '../../channel-details/optimizer/configuration/types';
import { tariffsForRequest } from '../../channel-details/optimizer/configuration/utils/tariff-kind';

type TariffConfigurationProviderState = {
  form: UseFormReturn<TariffConfigurationBody, any, TariffConfigurationBody>;
  formValues: TariffConfigurationBody;
  selectedTariff: TariffKindInternal | null;
};

const initialState: TariffConfigurationProviderState = {
  form: {} as UseFormReturn<TariffConfigurationBody, any, TariffConfigurationBody>,
  formValues: {
    operator: '',
    tariffName: '',
    wholeWeekendCheaper: false,
    wholeHolidaysCheaper: false,
    ignoreSummerTimeChanges: false,
    hoursRanges: [],
    prices: [],
  },
  selectedTariff: null,
};

export const TariffConfigurationContext = createContext<TariffConfigurationProviderState>(initialState);

export const useTariffConfigurationContext = (): TariffConfigurationProviderState =>
  useContext(TariffConfigurationContext);

export const TariffConfigurationContextProvider: React.FC<ChildrenProps> = ({ children }) => {
  const form = useForm<TariffConfigurationBody>({
    defaultValues: initialState.formValues,
  });

  const formValues = form.watch();

  const selectedTariff = useMemo(
    () => tariffsForRequest.find((x) => x.operator === formValues.operator && x.tariff === formValues.tariffName)?.enum,
    [formValues.operator, formValues.tariffName],
  );

  const values: TariffConfigurationProviderState = {
    form,
    formValues,
    selectedTariff: selectedTariff ? (selectedTariff as TariffKindInternal) : null,
  };

  return <TariffConfigurationContext.Provider value={values}>{children}</TariffConfigurationContext.Provider>;
};
